export default __webpack_public_path__ + "static/media/join-community.7e62f235.jpg";